import { render, staticRenderFns } from "./GemDetail.vue?vue&type=template&id=1acd434d&scoped=true&"
import script from "./GemDetail.vue?vue&type=script&lang=js&"
export * from "./GemDetail.vue?vue&type=script&lang=js&"
import style0 from "./GemDetail.vue?vue&type=style&index=0&id=1acd434d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acd434d",
  null
  
)

component.options.__file = "GemDetail.vue"
export default component.exports